import { getLink } from "../../../../utils/utils";

import translator from "../translator";

const content = {
	esp: (
		`
		<p class="mb-3">
			La Azeno fariĝis saĝa, fakto!
		</p>
		
		<p class="mb-3">
			Antaŭnelonge ili kune kun la Virŝafo aĉetis po plenĉaro de hejtŝtipoj. 
			Kaj jen, vidu: la Virŝafo jam ĉion elspezis, kaj antaŭ la domo de la Azeno – preskaŭ netuŝita ŝtiparo.
		</p>
		
		<p class="mb-3">
			Venis la Virŝafo al la Azeno por instruiĝi, kiel oni devas hejtlignon ŝpari. 
			Envenas kaj vidas: staras la Azeno meze de la ĉambro kaj movas tien-reen gigantan ŝtipon. 
			En la ĉambro malvarmegas, sed li eĉ la ŝviton de la frunto per hufo forviŝas: varmege!
		</p>
		
		<p class="mb-3">
			- Kion vi faras? – ekmiris la Virŝafo.
		</p>
		
		<p class="mb-3">
			- Ĉu vi ne vidas? Mi varmigas min, - respondas la Azeno. 
			– Bonegaj hejtŝtipoj okazis: unu ŝtipo por la tuta vintro sufiĉos!
		</p>
		
		<p class="mb-3">
			Mirigita revenas la Virŝafo hejmen. 
			Vere – unu ŝtipo por la tuta vintro! 
			Jen kia saĝa la Azeno fariĝis!
		</p>
		`
	)
}

const itemName = {
	esp: 'Energio de varmo'
}

const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content.esp,
		itemTranslator: translator.esp
	}
}

export default item;